var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "url(#pattern0_246_127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_246_127",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_246_127",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_246_127",
    width: 128,
    height: 128,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADsQAAA7EB9YPtSQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEfSURBVHic7dy9TQNBGEXRaywR0QAZjVABWMQUQRcg0QJd0AA/BVABRZCYHAJLDsjxwM450su/ZKWd5BYAAAAAAAAAAAALdFW9Vp/Vly1yn9VLtemH+z9wnB12d1Wrdl/+Y8xos64eqrPBhzDG6araViejL2GI7dHoCxjq66h6G30Fw7ytq4/qevQlDHGzrt6r4+p88DEc1m27B8DeZfXc7qdw9BvVfmfb6qm6CAAAAAAAAAAAAAAAAAAA+Md0Apc/nUDbTycQncDZ6QROTidwcjqBk9MJnJxO4MR0AiecTiAAAAAAAAAAAAAAAAAAACyCTuDypxNo++kEohM4O53AyekETk4ncHI6gZPTCZyYTuCE0wkEAAAAAAAAAABYrm+OvG8JqDb1ZwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.9d046b4d6a54cdfc9907d781bd1f9b10.svg";
export { ForwardRef as ReactComponent };